import React from 'react';
import { Typography } from '@ghq-abi/design-system-v2';

import type { CellValue } from '../types';

interface DefaultCellProps {
  value: CellValue | React.ReactNode;
}

export const DefaultCell: React.FC<DefaultCellProps> = ({ value }) => {
  if (React.isValidElement(value)) {
    return <>{value}</>;
  }

  return (
    <Typography variant="body-sm-regular" color="default">
      {value != null ? String(value) : 'N/A'}
    </Typography>
  );
};
